import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsSalesByDeviceTypeQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsSalesByDeviceTypeTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsSalesByDeviceTypeQuery({
    variables: { filter: filter as never },
  });

  const rows = (data?.analyticsSales.salesByDeviceType ?? []).map((row) => [
    row.label,
    formatNumber(row.sales),
    formatCurrency(row.revenue, data?.analyticsSales.currency ?? "USD"),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.sales.tableByDeviceType")}
      columns={[
        { name: t("analytics.sales.columnDevice") },
        { name: t("analytics.sales.columnSales") },
        { name: t("analytics.sales.columnRevenue") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.SalesByDeviceTypeType}
          filter={filter}
        />
      }
    />
  );
};
